import { render, staticRenderFns } from "./Vuex.vue?vue&type=template&id=765a8e49&"
import script from "./Vuex.vue?vue&type=script&lang=js&"
export * from "./Vuex.vue?vue&type=script&lang=js&"
import style0 from "./Vuex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports